<template>
  <ConfigLayout current="download">
    <ConfigPage title="予約情報ダウンロード" :loading="csv.busy">
      <div class="download">
        <CalendarInput
          v-model="startDate"
          :holidayList="allHolidays"
          :businessDay="businessDay"
          :reserveCalendar="reserveCalendar"
          :busy="busy"
          @setDate="setDate"
          @beforeShow="setDate(startDate)"
        />
        〜
        <CalendarInput
          v-model="endDate"
          :holidayList="allHolidays"
          :businessDay="businessDay"
          :reserveCalendar="reserveCalendar"
          :busy="busy"
          @setDate="setDate"
          @beforeShow="setDate(endDate)"
        />
        <Button class="button" small primary @click="download">データダウンロード</Button>
      </div>
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { format } from 'date-fns'
import { mapState, mapGetters } from 'vuex'
import { today } from '@/utils/date'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import CalendarInput from '@/components/molecules/CalendarInput'
import Button from '@/components/atoms/Button'

export default {
  name: 'Download',
  components: {
    ConfigLayout,
    ConfigPage,
    CalendarInput,
    Button,
  },
  data() {
    const date = today()
    return {
      startDate: date,
      endDate: date,
    }
  },
  computed: {
    ...mapState({
      csv: state => state.reserves.csv,
      businessDay: state => state.businessDay.list,
      busy: state => state.init.busy,
      reserveCalendar: state => state.init.reserveCalendar,
    }),
    ...mapGetters({
      allHolidays: 'holidays/all',
      blob: 'reserves/csv/blob',
    }),
  },
  watch: {
    startDate(date) {
      if (this.endDate < date) this.endDate = date
    },
    endDate(date) {
      if (date < this.startDate) this.startDate = date
    },
  },
  async created() {
    await this.$store.dispatch('holidays/get')
    await this.$store.dispatch('businessDay/get')
  },
  methods: {
    async download() {
      if (await this.$store.dispatch('reserves/csv/get', { startDate: this.startDate, endDate: this.endDate })) {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(this.blob)
        link.download = `${format(this.startDate, 'YYYYMMDD')}${
          this.startDate !== this.endDate ? `_${format(this.endDate, 'YYYYMMDD')}` : ''
        }_yoyaku.csv`
        link.click()
      }
    },
    async setDate(date) {
      await this.$store.dispatch('init/createCalendar', { date })
    },
  },
}
</script>

<style lang="postcss" scoped>
.download {
  align-items: center;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: flex-start;

  .button {
    padding: 0 8px;
    width: auto;
  }
}
</style>
